import { Button, H5, InputText } from "@sellar-io/components";
import { UserGetResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Icon } from "../../../components";
import { Alert } from "../../../components/alert/Alert";
import { InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../hooks/api/v2/apiV2Request";
import { useUserUpdate } from "../../../hooks/api/v2/user/useUserUpdate";

export const UserSettingsName = ({ user }: { user: UserGetResponseType }) => {
  const form = useForm<{
    name: string;
  }>({
    defaultValues: {
      name: user.name ?? "",
    },
  });

  const userUpdateMutation = useUserUpdate(parseInt(user.id.toString(), 10));

  const [modalActive, setModalActive] = useState(false);

  if (!user) throw new Error("Cannot find user");
  const [message, setMessage] = useState<string>();
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div className="cursor-pointer pb-4" onClick={() => setModalActive(true)}>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col">
            <H5>Name</H5>
            <span>{user.name ?? "No name set"}</span>
          </div>
          <Icon icon={"PENCIL"} color={"var(--theme-secondary-color)"} />
        </div>
      </div>
      <Dialog active={modalActive} onDismiss={() => setModalActive(false)}>
        <DialogNavigation
          title={"Update name"}
          description={"This will update your display name on Sellar."}
          leftIcon={"CHEVRON_DOWN"}
          onClickLeftIcon={() => setModalActive(false)}
        />
        <DialogContent>
          {message && <Alert type={"error"} message={message} />}
          <form>
            <InputContainer>
              <InputText
                {...form.register("name", { required: true })}
                placeholder={"Name"}
              />
            </InputContainer>
          </form>
        </DialogContent>
        <DialogCTA>
          <Button
            loading={loading}
            className={"w-full"}
            onClick={form.handleSubmit((data) => {
              setLoading(true);
              setMessage("");
              userUpdateMutation.mutate(
                {
                  data: {
                    name: data.name,
                  },
                },
                {
                  onSuccess: () => setModalActive(false),
                  onError: (error) => {
                    setMessage(apiV2AssertError(error)?.response?.data.message);
                  },
                  onSettled: () => {
                    setLoading(false);
                  },
                },
              );
            })}
          >
            Update
          </Button>
        </DialogCTA>
      </Dialog>
    </>
  );
};
